import { createReducer, on } from '@ngrx/store';

import { LoginEntityActions } from './login-entity.actions';
import { LoginEntityState, initialState } from './login-entity.state';

export const reducer = createReducer(
  initialState,
  on(LoginEntityActions.get_entity_start, (state: LoginEntityState) => ({
    ...state,
    error: null,
    loginEntityLoading: true
  })),
  on(LoginEntityActions.get_entity_success, LoginEntityActions.update_entity_success, (state, data) => {
    return {
      ...state,
      loginEntity: data.entity,
      error: null,
      loginEntityLoading: false
    };
  }),
  on(LoginEntityActions.get_entity_fail, (state, error) => ({
    ...state,
    loginEntity: null,
    error,
    loginEntityLoading: false
  }))
);
